import { useState } from 'react';
import { Access, AccessSource } from '@prisma/client';
import { Button, Modal } from 'antd';

import { SourceAccessItem } from '@app/domain-access-interfaces';
import { Mermaid, Modals } from '@app/web-components';

import { Dependency } from '../forms/use-bundle-form';

const getId = (node: SourceAccessItem | Access) =>
  `${node.accessSource}_${node.accessSource === AccessSource.IEM ? node.name : node.externalId}`;

type ViewDependenciesProps = {
  accesses?: (SourceAccessItem | Access)[];
  accessDependencies?: Dependency[];
};

export const ViewDependencies = ({ accesses, accessDependencies = [] }: ViewDependenciesProps) => {
  const [open, setOpen] = useState(false);
  const modalProps = Modals.useDraggable({ children: `Dependency Graph` });

  const onCancel = () => setOpen(false);

  return (
    <>
      <Modal
        styles={{
          body: {
            height: 600,
          },
        }}
        centered
        footer={[
          <Button key="close" type="primary" onClick={onCancel}>
            Close
          </Button>,
        ]}
        open={open}
        width={1100}
        onCancel={onCancel}
        {...modalProps}
      >
        {accesses?.length && (
          <Mermaid.Graph edges={accessDependencies} nodes={accesses} getName={(node) => node.name} getId={getId} />
        )}
      </Modal>
      <Button type="link" onClick={() => setOpen(true)}>
        Dependency Graph
      </Button>
    </>
  );
};
